import React from "react"
import DocumentListContainer from "./DocumentListContainer"

const IncidentDocumentsTab = ({ id, refetchQuery, viewType }) => (
    <DocumentListContainer
        mode="full"
        id={id}
        refetchQuery={refetchQuery}
        viewType={viewType || "incident"}
    />
)

export default IncidentDocumentsTab
